import(/* webpackMode: "eager", webpackExports: ["Inquiry"] */ "/codebuild/output/src3079947011/src/helloero-new/packages/help/src/app/(withLayout)/inquiry/(index)/_Inquiry/index.tsx");
